import {
    ADD_SUPPORT_FORUM,
    EDIT_SUPPORT_FORUM,
    GET_SUPPORTFORUM_LIST, PROPERTY_ERROR, SUPPORTFORUM_STATUS_UPDATE, SUPPORT_FORUM_DETAIL
} from "../types";

const initialState = {
    response: null,
    loading: true,
    create: false,
    detail: false,
};

export default function supportForumStore(state = initialState, action) {
    switch (action.type) {
        case GET_SUPPORTFORUM_LIST:
            return {
                ...state,
                create: false,
                detail: false,
                response: action.payload,
            };
        case SUPPORTFORUM_STATUS_UPDATE:
            return {
                ...state,
                detail: false,
                create: true,
                response: action.payload,
            };
        case ADD_SUPPORT_FORUM:
            return {
                ...state,
                detail: false,
                create: true,
                response: action.payload,
            };
        case EDIT_SUPPORT_FORUM:
            return {
                ...state,
                detail: false,
                create: true,
                response: action.payload,
            };
        case SUPPORT_FORUM_DETAIL:
            return {
                ...state,
                detail: true,
                create: false,
                response: action.payload,
            };
        case PROPERTY_ERROR:
            return {
                ...state,
                detail: true,
                create: true,
                response: action.payload,
            };
        default:
            return state;
    }
}
